import React, { useState } from 'react'
import {
  Card,
  Table,
  Button,
  Collapse,
  Row,
  Col,
  Tabs,
  Divider,
  message,
  Modal,
  Spin,
  Form,
  DatePicker,
  Tag
} from 'antd'
import PromoPic from '../../../assets/images/promotions.png'
import IntlMessages from '../../../util/IntlMessages'
import ds from '../../../Services/DataServices'
import Skeleton from 'react-loading-skeleton'
import { useHistory } from 'react-router-dom'
import { userLogOut } from '../../../appRedux/actions/Auth'
import { useDispatch, useStore, useSelector } from 'react-redux'
import moment from 'moment'
import { setCommonConfigs } from '../../../appRedux/actions/CommonData'
import { PROMOTION } from '../../../constants/Pages'
import {
  isEmptyObject,
  checkRightspermissions,
  notAllowMsgCheck,
  verifyPkgFeature
} from '../../../appRedux/actions/GlobalMethods'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
import {
  EditOutlined,
  CopyOutlined,
  CalendarOutlined,
  DeleteOutlined,
  UnorderedListOutlined
} from '@ant-design/icons'
// import { REACT_APP_BUS_FIRST_NAME } from '../../../constants/StoreSetting'
import { env } from '../../../env'
import NotAllowedComponent from '../../../components/NotAllowedComponent'
import { PkgFeatures } from '../../../constants/StoreEntities'

const { REACT_APP_BUS_FIRST_NAME } = env
const Panel = Collapse.Panel
const { TabPane } = Tabs
const confirm = Modal.confirm

const PromoListing = () => {
  const store = useStore()
  const dispatch = useDispatch()
  const history = useHistory()
  const [form] = Form.useForm()

  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )

  const [isLoading, setIsLoading] = React.useState(true)
  const [isPastLoading, setIsPastLoading] = React.useState(true)
  const [isAllLoading, setIsAllLoading] = React.useState(true)
  const [getDataCurrUp, setDataCurrUp] = React.useState([])
  const [getDataPast, setDataPast] = React.useState([])
  const [getDataAll, setDataAll] = React.useState([])
  const [isSpinningLoading, setSpinningLoading] = React.useState(false)
  const [isLoadingCurrentTable, setIsLoadingCurrentTable] =
    React.useState(false)
  const [isLoadingPastTable, setIsLoadingPastTable] = React.useState(false)
  const [isLoadingAllTable, setIsLoadingAllTable] = React.useState(false)
  const [getIsEndEarlyVisible, setIsEndEarlyVisible] = React.useState(false)
  const [getEndEalryCard, setEndEalryCard] = React.useState(1)
  const [getEndDate, setEndDate] = React.useState(1)
  const [getPromoID, setPromoID] = React.useState('')
  const [getCurrentPagination, setCurrentPagination] = React.useState({
    CurrentPageNo: 1,
    PageSize: 10,
    showSizeChanger: true,
    IsCurrent: true
  })
  const [getPastPagination, setPastPagination] = React.useState({
    CurrentPageNo: 1,
    PageSize: 10,
    showSizeChanger: true,
    IsPast: true
  })
  const [getAllPagination, setAllPagination] = React.useState({
    CurrentPageNo: 1,
    PageSize: 10,
    showSizeChanger: true
  })
  const [getIsDisableCreate, setIsDisableCreate] = useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = useState(true)
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])
  const [getCurrData, setCurrData] = useState({
    currencyCode: '',
    currencySymbol: ''
  })
  const [isFeatureAllowed, setIsFeatureAllowed] = useState(true)
  //setIsEndEarlyVisible

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      if (!verifyPkgFeature(PkgFeatures.Promotions)) {
        setIsFeatureAllowed(false)
      }
      dispatch(setCommonConfigs(PROMOTION))
      getUpcomingData(getCurrentPagination, PkgFeatures.Promotions)
      getPastData(getPastPagination, PkgFeatures.Promotions)
      getAllData(getAllPagination, PkgFeatures.Promotions)
    }
    return () => {
      mounted = false
    }
  }, [])

  //for common data -> store currency
  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      const commonData = getReduxCommonSetting
      const respData =
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig
          ? commonData.storeCommonConfigs.storeConfig
          : {}
      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData
        setCurrData(currencyData)
      }
      // rights && permissions
      if (commonData && commonData.storeCommonConfigs) {
        const rpData = checkRightspermissions(commonData)
        if (rpData && !isEmptyObject(rpData)) {
          setupRightsPermissions(rpData)
          setAccessLoading(false)
        } else {
          toInitialState()
          setAccessLoading(false)
        }
      }
    }

    return () => (mounted = false)
  }, [getReduxCommonSetting])

  function toInitialState () {
    setRights([])
    setPermissions([])
    setIsAllowRead(false)
    setIsDisableCreate(true)
    setIsDisableUpdate(true)
    setIsDisableDelete(true)
    setAccessLoading(true)
  }

  function setupRightsPermissions (rpData) {
    if (rpData.rights && rpData.rights.length > 0) {
      setRights(rpData.rights)
    } else {
      setRights([])
    }
    if (rpData.permissions && rpData.permissions.length > 0) {
      setPermissions(rpData.permissions)
    } else {
      setPermissions([])
    }
    if (rpData.read) {
      setIsAllowRead(true)
    } else {
      setIsAllowRead(false)
    }
    if (rpData.create) {
      setIsDisableCreate(false)
    } else {
      setIsDisableCreate(true)
    }
    if (rpData.update) {
      setIsDisableUpdate(false)
    } else {
      setIsDisableUpdate(true)
    }
    if (rpData.delete) {
      setIsDisableDelete(false)
    } else {
      setIsDisableDelete(true)
    }
  }

  async function getUpcomingData (body, featureID) {
    const getUpcommingData = ds.getPromotions(
      body,
      BEHAVIOUR_TYPE.GET,
      featureID
    )
    await getUpcommingData
      .then(res => {
        if (res.data.data.promotions && res.data.data.promotions.length > 0) {
          let mapped = res.data.data.promotions.map(promo => {
            return {
              key: promo.forListPromotionID,
              name: promo.promoName,
              desc: promo.promoDesc,
              availon: promo.availableOn,
              startdate: promo.startDate,
              enddate: promo.endDate,
              ongroups: promo.onGroups,
              outlets: promo.promoOutlets,
              customers: promo.promoCustomers,
              createdon: promo.createdOn
            }
          })
          let paginationobj = {
            CurrentPageNo: res.data.data.promotions[0].currentPageNo,
            PageSize: res.data.data.promotions[0].pageSize,
            total: res.data.data.promotions[0].totalRecords,
            showSizeChanger: true,
            IsCurrent: true
          }
          setCurrentPagination(paginationobj)
          mapped.sort((a, b) => (a.createdon < b.createdon ? 1 : -1))
          setDataCurrUp(mapped)
        }
        setIsLoading(false)
        setIsLoadingCurrentTable(false)
      })
      .catch(e => {
        notAllowMsgCheck(e)
        setIsLoading(false)
        setIsLoadingCurrentTable(false)
        // if (e.response && e.response.status === 401) {
        //   message.error("Token Expired! Redirecting to Login Page");
        //   setTimeout(() => {
        //     dispatch(userLogOut(store.getState()));
        //   }, 3000);
        // } else {
        //   message.error("Something went wrong...");
        // }
      }) //console.log("CatchAddEditBook", e));
  }
  async function getPastData (body, featureID) {
    //;
    const getPasstData = ds.getPromotions(body, BEHAVIOUR_TYPE.GET, featureID)
    await getPasstData
      .then(res => {
        setIsPastLoading(false)
        setIsLoadingPastTable(false)
        if (res.data.data.promotions && res.data.data.promotions.length > 0) {
          let mapped = res.data.data.promotions.map(promo => {
            return {
              key: promo.forListPromotionID,
              name: promo.promoName,
              desc: promo.promoDesc,
              availon: promo.availableOn,
              startdate: promo.startDate,
              enddate: promo.endDate,
              ongroups: promo.onGroups,
              outlets: promo.promoOutlets,
              customers: promo.promoCustomers,
              createdon: promo.createdOn
            }
          })
          let paginationobj = {
            CurrentPageNo: res.data.data.promotions[0].currentPageNo,
            PageSize: res.data.data.promotions[0].pageSize,
            total: res.data.data.promotions[0].totalRecords,
            showSizeChanger: true,
            IsPast: true
          }
          setPastPagination(paginationobj)
          mapped.sort((a, b) => (a.createdon < b.createdon ? 1 : -1))
          setDataPast(mapped)
        }
      })
      .catch(e => {
        notAllowMsgCheck(e)
        setIsPastLoading(false)
        setIsLoadingPastTable(false)
      })
  }
  async function getAllData (body, featureID) {
    //;
    const getAlllData = ds.getPromotions(body, BEHAVIOUR_TYPE.GET, featureID)
    await getAlllData
      .then(res => {
        setIsAllLoading(false)
        setIsLoadingAllTable(false)
        if (res.data.data.promotions && res.data.data.promotions.length > 0) {
          let mapped = res.data.data.promotions.map(promo => {
            return {
              key: promo.forListPromotionID,
              name: promo.promoName,
              desc: promo.promoDesc,
              availon: promo.availableOn,
              startdate: promo.startDate,
              enddate: promo.endDate,
              ongroups: promo.onGroups,
              outlets: promo.promoOutlets,
              customers: promo.promoCustomers,
              createdon: promo.createdOn
            }
          })
          let paginationobj = {
            CurrentPageNo: res.data.data.promotions[0].currentPageNo,
            PageSize: res.data.data.promotions[0].pageSize,
            total: res.data.data.promotions[0].totalRecords,
            showSizeChanger: true
          }
          setAllPagination(paginationobj)
          mapped.sort((a, b) => (a.createdon < b.createdon ? 1 : -1))
          setDataAll(mapped)
        }
      })
      .catch(e => {
        notAllowMsgCheck(e)
        setIsAllLoading(false)
        setIsLoadingAllTable(false)
      })
  }

  const columns = [
    {
      title: <IntlMessages id='products.promotionlisting.startdate' />,
      dataIndex: 'startdate',
      key: 'startdate',
      render: text => {
        return <span style={{ fontWeight: '500' }}>{text}</span>
      }
    },
    {
      title: <IntlMessages id='products.promotionlisting.enddate' />,
      dataIndex: 'enddate',
      key: 'enddate',
      render: text => {
        return <span style={{ fontWeight: '500' }}>{text}</span>
      }
    },
    {
      title: <IntlMessages id='products.promotionlisting.name' />,
      dataIndex: 'name',
      key: 'name',
      render: text => {
        return (
          <span className='gx-link' style={{ fontWeight: '500' }}>
            {text}
          </span>
        )
      }
    },
    {
      title: <IntlMessages id='products.promotionlisting.availableon' />,
      dataIndex: 'availon',
      key: 'availon',
      render: text => {
        return <span style={{ fontWeight: '500' }}>{text}</span>
      }
    },
    {
      title: <IntlMessages id='products.promotionlisting.edit' />,
      dataIndex: 'edit',
      key: 'edit',
      render: (text, record) => {
        return getIsDisableUpdate ? (
          <Tag color='#f50'>
            <strong>
              <IntlMessages id='dakarpos.allow.accessdenied' />
            </strong>
          </Tag>
        ) : (
          <div>
            <span>
              <a
                onClick={() =>
                  history.push(
                    `/Dashboard/products/promotions/edit/${record.key}`
                  )
                }
                className='pen-edit'
              >
                <i className='icon icon-edit' />
              </a>
            </span>
          </div>
        )
      }
    }
  ]

  const deletePromotions = async id => {
    setSpinningLoading(true)
    let addUpdateDeletePromo = {
      data: {
        msgCode: '',
        msgDescription: ''
      }
    }
    await ds
      .addUpdateDeletePromotion(
        {
          PromotionID: id,
          IsRemove: true,
          BehaviorName: 2
        },
        BEHAVIOUR_TYPE.DELETE
      )
      .then(response => (addUpdateDeletePromo.data = response.data))
      .catch(e => {
        notAllowMsgCheck(e)
        // console.log("CatchPromoDel", e);
      })

    if (addUpdateDeletePromo.data.msgCode == 'GENERAL_SUCCESS') {
      setSpinningLoading(false)
      message.success('Promotion Deleted')
      setDataCurrUp(getDataCurrUp.filter(a => a.key !== id))
      setDataAll(getDataAll.filter(a => a.key !== id))
      setDataPast(getDataPast.filter(a => a.key !== id))
      //history.push("/Dashboard/products/Brands");
      //setTimeout(() => {
      //    window.location.href = "/Dashboard/products/Brands";
      //}, 2000);
    }

    if (addUpdateDeletePromo.data.msgCode == 'GENERAL_ERROR') {
      setSpinningLoading(false)
      message.error(addUpdateDeletePromo.data.msgDescription)
    }
    setSpinningLoading(false)
  }

  function showDeleteConfirm (id, name) {
    confirm({
      title: 'Are you sure delete this Promotion?',
      content: `"${name}"`,
      okText: 'Yes',
      cancelText: 'No',
      okButtonProps: { className: 'dk-btn-add close-reg-btn' },
      cancelButtonProps: { className: 'dk-btn-cancel close-reg-btn' },
      onOk () {
        deletePromotions(id)
      },
      onCancel () {
        //console.log('Cancel');
      }
    })
  }

  function showEndEarly (enddate, id) {
    setIsEndEarlyVisible(true)
    setEndDate(enddate)
    setPromoID(id)
  }

  function handleEndEarlyCancel () {
    setIsEndEarlyVisible(false)
    setEndEalryCard(1)
  }

  const cardClickFunction = value => {
    if (value == 1) {
      setEndEalryCard(1)
    } else if (value == 2) {
      setEndEalryCard(2)
    }
  }

  const onFinish = async values => {
    setSpinningLoading(true)
    setIsEndEarlyVisible(false)
    let addEditPromo = {
      data: {
        data: Object,
        msgCode: '',
        msgDescription: ''
      }
    }

    await ds
      .addUpdateDeletePromotion(
        {
          IsEndEarly: true,
          IsEndNow: values === 'now' ? true : false,
          PromotionID: getPromoID,
          EndDate:
            values !== 'now'
              ? values.endEarlyDate !== undefined
                ? values.endEarlyDate.format('DD/MM/YYYY hh:mm')
                : undefined
              : undefined,
          BehaviorName: 3
        },
        BEHAVIOUR_TYPE.UPDATE
      )
      .then(response => (addEditPromo.data = response.data))
      .catch(e => {
        notAllowMsgCheck(e)
        setSpinningLoading(false)
        // console.log('CatchAddPriceBook', e)
        message.error('Sorry! Check Internet Connection...')
      })

    if (addEditPromo.data.msgCode == 'GENERAL_SUCCESS') {
      setSpinningLoading(false)
      if (addEditPromo.data.data === 'Input Data Missing') {
        message.error('Kindly attend to wrong information')
      } else {
        getUpcomingData({}, PkgFeatures.Promotions)
        getPastData({}, PkgFeatures.Promotions)
        getAllData({}, PkgFeatures.Promotions)
        message.success('Successfully Updated Promotion')
      }
      //setTimeout(() => {
      //    let id = addEditPromo.data.data;
      //    history.push(`/Dashboard/products/pricebook/customprices/${id}`);
      //}, 2000);
    }

    if (addEditPromo.data.msgCode == 'GENERAL_ERROR') {
      setSpinningLoading(false)
      message.error(addEditPromo.data.msgDescription)
    }
    setSpinningLoading(false)
  }

  const onFinishFailed = errorInfo => {
    message.error('Kindly Attend to Missing Fields')
  }

  const handleCurrentTableChange = (pagination, filters, sorter) => {
    setIsLoadingCurrentTable(true)
    var body = getCurrentPagination
    body.CurrentPageNo = pagination.current
    body.PageSize = pagination.pageSize
    getUpcomingData(body, PkgFeatures.Promotions)
  }

  const handlePastTableChange = (pagination, filters, sorter) => {
    setIsLoadingPastTable(true)
    var body = getPastPagination
    body.CurrentPageNo = pagination.current
    body.PageSize = pagination.pageSize
    getPastData(body, PkgFeatures.Promotions)
  }

  const handleAllTableChange = (pagination, filters, sorter) => {
    setIsLoadingAllTable(true)
    var body = getAllPagination
    body.CurrentPageNo = pagination.current
    body.PageSize = pagination.pageSize
    getAllData(body, PkgFeatures.Promotions)
  }

  //<Button className="custom-promolist-vpbtn">{<IntlMessages id="products.promotionlisting.vieproducts" />}</Button>

  return getIsAllowRead && isFeatureAllowed ? (
    <>
      {isSpinningLoading ? (
        <Spin
          tip={<IntlMessages id='products.promotionlisting.promoalert' />}
          spinning={isSpinningLoading}
          size='large'
        >
          <div className='gx-main-content-wrapper'>
            <Row>
              <Col md={6}>
                <h1 style={{ fontWeight: '500' }} className='title gx-mb-4'>
                  <IntlMessages id='products.promotionlisting.promo' />
                </h1>
              </Col>
              <Col md={18}>
                <div style={{ textAlign: 'right', marginBottom: '16px' }}>
                  <Button
                    className='custom-btn-addbtn orange-btn-div'
                    type='primary'
                    onClick={() => {
                      history.push('/Dashboard/products/promotions/add')
                    }}
                    size='large'
                  >
                    <IntlMessages id='products.promotionlisting.addpromo' />
                  </Button>
                </div>
              </Col>
            </Row>

            <Card className='gx-card' title=''>
              <Collapse>
                <Panel
                  className='custom-promolist-help'
                  showArrow={false}
                  header={<IntlMessages id='products.promotionlisting.help' />}
                >
                  <Row>
                    <div className='billing-main'>
                      <Col className='custom-promolist-helpdesc' md={12}>
                        <p>
                          <IntlMessages id='products.promotionlisting.needhelpdescription1' />
                          <a href='#'>
                            <IntlMessages id='products.promotionlisting.needhelpdescription2' />
                            .
                          </a>
                        </p>
                        <p>
                          <IntlMessages id='products.promotionlisting.needhelpdescription3' />
                          <a href='#'>
                            <IntlMessages
                              id='products.promotionlisting.needhelpdescription4'
                              values={{
                                strong: chunks => <strong>{chunks}</strong>,
                                bus_name_first: REACT_APP_BUS_FIRST_NAME
                              }}
                            />
                            .
                          </a>
                        </p>
                      </Col>

                      <Col md={12}>
                        <img
                          style={{ marginLeft: '150px' }}
                          src={PromoPic}
                          alt=''
                        />
                      </Col>
                    </div>
                  </Row>
                </Panel>
              </Collapse>
            </Card>

            <Card>
              <Tabs defaultActiveKey='1' size='large'>
                <TabPane
                  tab={<IntlMessages id='products.promotionlisting.tab1' />}
                  key='1'
                >
                  <Card title=''></Card>
                </TabPane>
              </Tabs>
            </Card>
          </div>
        </Spin>
      ) : (
        <div className='Content-wrapper Promotions-pg'>
          <Row className='align-items-center justify-content-center mb-3 Promotions-header'>
            <Col lg={12} md={12} sm={24} xs={24}>
              <h1 className='mb-0'>
                <IntlMessages id='products.promotionlisting.promo' />
              </h1>
            </Col>
            <Col lg={12} md={12} sm={24} xs={24}>
              {!getIsDisableCreate && (
                <div className='pg-header-btn'>
                  <Button
                    className='dk-btn-add'
                    type='primary'
                    onClick={() => {
                      history.push('/Dashboard/products/promotions/add')
                    }}
                    size='large'
                  >
                    <IntlMessages id='products.promotionlisting.addpromo' />
                  </Button>
                </div>
              )}
            </Col>
          </Row>

          <Card className='gx-card' title=''>
            <Collapse>
              <Panel
                className='custom-promolist-help'
                showArrow={false}
                header={<IntlMessages id='products.promotionlisting.help' />}
              >
                <Row>
                  <div className='billing-main'>
                    <Col className='custom-promolist-helpdesc' md={12}>
                      <p>
                        <IntlMessages id='products.promotionlisting.needhelpdescription1' />
                        <IntlMessages id='products.promotionlisting.needhelpdescription2' />
                        .
                        {/* <a href='#'>
                          <IntlMessages id='products.promotionlisting.needhelpdescription2' />
                          .
                        </a> */}
                      </p>
                      <p>
                        <IntlMessages id='products.promotionlisting.needhelpdescription3' />
                        <IntlMessages
                          id='products.promotionlisting.needhelpdescription4'
                          values={{
                            strong: chunks => <strong>{chunks}</strong>,
                            bus_name_first: REACT_APP_BUS_FIRST_NAME
                          }}
                        />
                        {/* <a href='#'>
                          <IntlMessages
                            id='products.promotionlisting.needhelpdescription4'
                            values={{
                              strong: chunks => <strong>{chunks}</strong>,
                              bus_name_first: REACT_APP_BUS_FIRST_NAME
                            }}
                          />
                          .
                        </a> */}
                      </p>
                    </Col>

                    <Col md={12}>
                      <img src={PromoPic} alt='' />
                    </Col>
                  </div>
                </Row>
              </Panel>
            </Collapse>
          </Card>

          <Card className='tab-body-parent'>
            <Tabs defaultActiveKey='1' size='large'>
              <TabPane
                tab={
                  <span className='dk-fnt-wgt'>
                    <IntlMessages id='products.promotionlisting.tab1' />{' '}
                  </span>
                }
                key='1'
                // style={{ fontWeight: "bold" }}
              >
                <Card title=''>
                  {isLoading ? (
                    <Skeleton count={5} height={30} />
                  ) : (
                    <Table
                      className='gx-table-responsive MinWidth-auto'
                      columns={columns}
                      expandedRowRender={record => {
                        return (
                          <div
                            style={{ padding: 12 }}
                            className='custom-box-shadow'
                          >
                            <Row>
                              <Col lg={8} md={24} sm={24} xs={24}>
                                <h2 class='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
                                  {record.name}
                                </h2>
                                <p class='dk-font-size-15'>{record.desc}</p>
                              </Col>
                              <Col lg={8} md={18} sm={24} xs={24}>
                                <h4 className='mb-0'>
                                  <IntlMessages id='products.promotionlisting.availableon' />
                                </h4>
                                <Divider className='custom-promolist-divider mt-2 mb-2' />
                                <Row>
                                  <Col lg={8} md={12} sm={24} xs={24}>
                                    <h5>{record.availon}:</h5>
                                  </Col>
                                  <Col lg={16} md={12} sm={24} xs={24}>
                                    {record.outlets.map((e, key) => {
                                      return <p key={key}>{e.outletName}</p>
                                    })}
                                  </Col>
                                </Row>
                                <h4 className='mb-0 mt-3'>
                                  {
                                    <IntlMessages id='products.promotionlisting.customergroups' />
                                  }
                                </h4>
                                <Divider className='custom-promolist-divider mt-2 mb-2' />
                                <Row>
                                  <Col lg={8} md={12} sm={24} xs={24}>
                                    <h5>Exclusive to {record.ongroups}:</h5>
                                  </Col>
                                  <Col lg={16} md={12} sm={24} xs={24}>
                                    {record.customers.map((e, key) => {
                                      return (
                                        <p key={key}>{e.customerGroupName}</p>
                                      )
                                    })}
                                  </Col>
                                </Row>
                              </Col>
                              <Col lg={8} md={6} sm={24} xs={24}>
                                <div className='dk-expand-btn-mobile'>
                                  <Button
                                    className='dk-btn-edit-expand dk-wd-auto dk-hgt-50 edit-text-btn'
                                    onClick={() =>
                                      history.push(
                                        `/Dashboard/products/promotions/edit/${record.key}`
                                      )
                                    }
                                    icon={
                                      <EditOutlined className='dk-btn-icon-align' />
                                    }
                                    disabled={getIsDisableUpdate}
                                  >
                                    {
                                      <IntlMessages id='products.promotionlisting.edit' />
                                    }
                                  </Button>
                                  <Button
                                    className='dk-btn-edit-expand dk-wd-auto dk-hgt-50 inventory-text-btn'
                                    onClick={() =>
                                      history.push(
                                        `/Dashboard/products/promotions/duplicate/${record.key}`
                                      )
                                    }
                                    icon={
                                      <CopyOutlined className='dk-btn-icon-align' />
                                    }
                                    disabled={getIsDisableCreate}
                                  >
                                    {
                                      <IntlMessages id='products.promotionlisting.duplicate' />
                                    }
                                  </Button>
                                  <Button
                                    className='dk-btn-expand-early dk-wd-auto dk-hgt-50'
                                    onClick={() =>
                                      showEndEarly(record.enddate, record.key)
                                    }
                                    icon={
                                      <CalendarOutlined className='dk-btn-icon-align' />
                                    }
                                    disabled={getIsDisableUpdate}
                                  >
                                    {
                                      <IntlMessages id='products.promotionlisting.endearly' />
                                    }
                                  </Button>
                                  <Button
                                    className='dk-btn-expand-del dk-mg-tp-20 dk-mg-bt-20 dk-wd-auto dk-hgt-50'
                                    onClick={() =>
                                      showDeleteConfirm(record.key, record.name)
                                    }
                                    icon={
                                      <DeleteOutlined className='dk-btn-icon-align' />
                                    }
                                    disabled={getIsDisableDelete}
                                  >
                                    {
                                      <IntlMessages id='products.promotionlisting.delete' />
                                    }
                                  </Button>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        )
                      }}
                      loading={isLoadingCurrentTable}
                      dataSource={getDataCurrUp}
                      pagination={getCurrentPagination}
                      onChange={handleCurrentTableChange}
                      expandRowByClick
                      // rowKey={(record) => record.key}
                    />
                  )}
                </Card>
              </TabPane>
              <TabPane
                tab={
                  <span className='dk-fnt-wgt'>
                    <IntlMessages id='products.promotionlisting.tab2' />{' '}
                  </span>
                }
                key='2'
              >
                <Card title=''>
                  {isPastLoading ? (
                    <Skeleton count={5} height={30} />
                  ) : (
                    <Table
                      className='gx-table-responsive MinWidth-auto'
                      columns={columns}
                      expandedRowRender={record => {
                        return (
                          <div>
                            <Row>
                              <Col lg={8} md={24} sm={24} xs={24}>
                                <h2 class='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
                                  {record.name}
                                </h2>
                                <p class='dk-font-size-15'>{record.desc}</p>
                              </Col>
                              <Col lg={8} md={18} sm={24} xs={24}>
                                <h4 className='mb-0'>
                                  <IntlMessages id='products.promotionlisting.availableon' />
                                </h4>
                                <Divider className='custom-promolist-divider mt-2 mb-2' />
                                <Row>
                                  <Col lg={8} md={12} sm={24} xs={24}>
                                    <h5>{record.availon}:</h5>
                                  </Col>
                                  <Col lg={16} md={12} sm={24} xs={24}>
                                    {record.outlets.map((e, key) => {
                                      return <p key={key}>{e.outletName}</p>
                                    })}
                                  </Col>
                                </Row>
                                <h4 className='mb-0'>
                                  <IntlMessages id='products.promotionlisting.customergroups' />{' '}
                                </h4>
                                <Divider className='custom-promolist-divider mt-2 mb-2' />
                                <Row>
                                  <Col lg={8} md={12} sm={24} xs={24}>
                                    <h5>Exclusive to {record.ongroups}:</h5>
                                  </Col>
                                  <Col lg={16} md={12} sm={24} xs={24}>
                                    {record.customers.map((e, key) => {
                                      return (
                                        <p key={key}>{e.customerGroupName}</p>
                                      )
                                    })}
                                  </Col>
                                </Row>
                              </Col>
                              <Col lg={8} md={6} sm={24} xs={24}>
                                <div>
                                  <Button
                                    className='dk-btn-edit-expand dk-wd-auto dk-hgt-50 edit-text-btn'
                                    onClick={() =>
                                      history.push(
                                        `/Dashboard/products/promotions/edit/${record.key}`
                                      )
                                    }
                                    icon={
                                      <EditOutlined className='dk-btn-icon-align' />
                                    }
                                    disabled={getIsDisableUpdate}
                                  >
                                    <IntlMessages id='products.promotionlisting.edit' />
                                  </Button>
                                  <br />
                                  <Button
                                    className='dk-btn-edit-expand dk-wd-auto dk-hgt-50 inventory-text-btn'
                                    onClick={() =>
                                      history.push(
                                        `/Dashboard/products/promotions/duplicate/${record.key}`
                                      )
                                    }
                                    icon={
                                      <CopyOutlined className='dk-btn-icon-align' />
                                    }
                                    disabled={getIsDisableCreate}
                                  >
                                    <IntlMessages id='products.promotionlisting.duplicate' />
                                  </Button>
                                  <br />
                                  <Button
                                    className='dk-btn-expand-early dk-wd-auto dk-hgt-50 inventory-text-btn'
                                    onClick={() =>
                                      showEndEarly(record.enddate, record.key)
                                    }
                                    icon={
                                      <CalendarOutlined className='dk-btn-icon-align' />
                                    }
                                    disabled={getIsDisableUpdate}
                                  >
                                    <IntlMessages id='products.promotionlisting.endearly' />
                                  </Button>
                                  <br />
                                  <Button
                                    className='dk-btn-expand-del dk-mg-tp-20 dk-mg-bt-20 dk-wd-auto dk-hgt-50'
                                    onClick={() =>
                                      showDeleteConfirm(record.key, record.name)
                                    }
                                    icon={
                                      <DeleteOutlined className='dk-btn-icon-align' />
                                    }
                                    disabled={getIsDisableDelete}
                                  >
                                    <IntlMessages id='products.promotionlisting.delete' />
                                  </Button>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        )
                      }}
                      loading={isLoadingPastTable}
                      dataSource={getDataPast}
                      pagination={getPastPagination}
                      onChange={handlePastTableChange}
                      expandRowByClick
                      // rowKey={(record) => record.key}
                    />
                  )}
                </Card>
              </TabPane>
              <TabPane
                tab={
                  <span className='dk-fnt-wgt'>
                    <IntlMessages id='products.promotionlisting.tab3' />{' '}
                  </span>
                }
                key='3'
              >
                <Card title=''>
                  {isAllLoading ? (
                    <Skeleton count={5} height={30} />
                  ) : (
                    <Table
                      className='gx-table-responsive MinWidth-auto'
                      columns={columns}
                      expandedRowRender={record => {
                        return (
                          <div>
                            <Row>
                              <Col lg={8} md={24} sm={24} xs={24}>
                                <h2 class='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
                                  {record.name}
                                </h2>
                                <p class='dk-font-size-15'>{record.desc}</p>
                              </Col>
                              <Col lg={8} md={18} sm={24} xs={24}>
                                <h4 class='mb-0'>
                                  <IntlMessages id='products.promotionlisting.availableon' />
                                </h4>
                                <Divider className='custom-promolist-divider mt-2 mb-2' />
                                <Row>
                                  <Col lg={8} md={12} sm={24} xs={24}>
                                    <h5>{record.availon}:</h5>
                                  </Col>
                                  <Col lg={16} md={12} sm={24} xs={24}>
                                    {record.outlets.map((e, key) => {
                                      return <p key={key}>{e.outletName}</p>
                                    })}
                                  </Col>
                                </Row>
                                <h4
                                  style={{ fontWeight: '500' }}
                                  className='custom-promolist-custhead'
                                >
                                  <IntlMessages id='products.promotionlisting.customergroups' />{' '}
                                </h4>
                                <Divider className='custom-promolist-divider' />
                                <Row>
                                  <Col lg={8} md={12} sm={24} xs={24}>
                                    <h5>Exclusive to {record.ongroups}:</h5>
                                  </Col>
                                  <Col lg={16} md={12} sm={24} xs={24}>
                                    {record.customers.map((e, key) => {
                                      return (
                                        <p key={key}>{e.customerGroupName}</p>
                                      )
                                    })}
                                  </Col>
                                </Row>
                              </Col>
                              <Col lg={8} md={6} sm={24} xs={24}>
                                <div>
                                  <Button
                                    type='primary'
                                    size='large'
                                    className='dk-btn-edit-expand edit-text-btn dk-wd-auto{'
                                    onClick={() =>
                                      history.push(
                                        `/Dashboard/products/promotions/edit/${record.key}`
                                      )
                                    }
                                    icon={
                                      <EditOutlined className='dk-btn-icon-align' />
                                    }
                                    disabled={getIsDisableUpdate}
                                  >
                                    <IntlMessages id='products.promotionlisting.edit' />
                                  </Button>
                                  <br />
                                  <Button
                                    type='primary'
                                    size='large'
                                    className='dk-btn-edit-expand dk-wd-auto inventory-text-btn'
                                    onClick={() =>
                                      history.push(
                                        `/Dashboard/products/promotions/duplicate/${record.key}`
                                      )
                                    }
                                    icon={
                                      <CopyOutlined className='dk-btn-icon-align' />
                                    }
                                    disabled={getIsDisableCreate}
                                  >
                                    <IntlMessages id='products.promotionlisting.duplicate' />
                                  </Button>
                                  <br />
                                  <Button
                                    className='dk-btn-expand-early dk-wd-auto inventory-text-btn'
                                    type='primary'
                                    size='large'
                                    onClick={() =>
                                      showEndEarly(record.enddate, record.key)
                                    }
                                    icon={
                                      <CalendarOutlined className='dk-btn-icon-align' />
                                    }
                                    disabled={getIsDisableUpdate}
                                  >
                                    <IntlMessages id='products.promotionlisting.endearly' />
                                  </Button>
                                  <br />
                                  <Button
                                    className='dk-btn-expand-del dk-mg-tp-20 dk-mg-bt-20 dk-wd-auto del-btn-adj'
                                    type='primary'
                                    size='large'
                                    onClick={() =>
                                      showDeleteConfirm(record.key, record.name)
                                    }
                                    icon={
                                      <DeleteOutlined className='dk-btn-icon-align' />
                                    }
                                    disabled={getIsDisableDelete}
                                  >
                                    <IntlMessages id='products.promotionlisting.delete' />
                                  </Button>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        )
                      }}
                      dataSource={getDataAll}
                      loading={isLoadingAllTable}
                      pagination={getAllPagination}
                      onChange={handleAllTableChange}
                      expandRowByClick
                      // rowKey={(record) => record.key}
                    />
                  )}
                </Card>
              </TabPane>
            </Tabs>
          </Card>

          <Modal
            visible={getIsEndEarlyVisible}
            onCancel={handleEndEarlyCancel}
            centered={true}
            width={'800px'}
            footer={null}
          >
            <div className='custom-promoadd-maindiv'>
              <Row>
                <h2 className='custom-promolist-endearlypophead'>
                  <IntlMessages id='products.promotionlisting.endearlypopup' />
                </h2>
              </Row>

              <Row>
                <p className='custom-promolist-endearlypopdesc'>
                  <IntlMessages id='products.promotionlisting.endearlypopupdesc1' />
                </p>
              </Row>

              <Row>
                <p className='custom-promolist-endearlypopdesc2'>
                  <IntlMessages id='products.promotionlisting.endearlypopupdesc2' />
                  <strong>{getEndDate}</strong>
                </p>
              </Row>

              <Row>
                <Col span={12}>
                  <div className='custom-promolist-card1'>
                    <Card
                      style={{
                        textAlign: 'Center',
                        borderRadius: 'inherit',
                        display: 'grid',
                        borderWidth: '4px'
                      }}
                      className={`${
                        getEndEalryCard == 1 ? 'ant-card-bordered-active' : ''
                      }`}
                      onClick={() => cardClickFunction(1)}
                    >
                      <p className='custom-promolisting-cardptext'>
                        <IntlMessages id='products.promotionlisting.endnow' />
                      </p>
                    </Card>
                  </div>
                </Col>

                <Col span={12}>
                  <div className='custom-promolist-card2'>
                    <Card
                      style={{
                        textAlign: 'Center',
                        borderRadius: 'inherit',
                        display: 'grid',
                        borderWidth: '4px'
                      }}
                      className={`${
                        getEndEalryCard == 2 ? 'ant-card-bordered-active' : ''
                      }`}
                      onClick={() => cardClickFunction(2)}
                    >
                      <p className='custom-promolisting-cardptext'>
                        <IntlMessages id='products.promotionlisting.setnewend' />
                      </p>
                    </Card>
                  </div>
                </Col>
              </Row>

              {getEndEalryCard === 1 ? (
                <>
                  <Row>
                    <Col span={17}></Col>
                    <Col span={7}>
                      <Button
                        className='dk-btn-add  dk-btn-promo-end dk-hgt-50 dk-wd-200'
                        type='primary'
                        onClick={() => onFinish('now')}
                      >
                        <IntlMessages id='products.promotionlisting.emdpromo' />
                      </Button>
                    </Col>
                  </Row>
                </>
              ) : (
                <>
                  <Row>
                    <Col span={24}>
                      <p>
                        <strong>
                          <IntlMessages id='products.promotionlisting.endatetime' />
                        </strong>{' '}
                      </p>
                    </Col>
                  </Row>

                  <Row>
                    <Col span={24}>
                      <Form name='endEarlyForm' form={form} scrollToFirstError>
                        <Form.Item
                          className='ant-form-item-label-custom ant-form-margin-right  ant-form-custom-alignment'
                          name='endEarlyDate'
                          rules={[
                            {
                              required:
                                getIsEndEarlyVisible && getEndEalryCard !== 1
                                  ? true
                                  : false,
                              message: (
                                <IntlMessages id='products.promotionlisting.disperalert' />
                              )
                            }
                          ]}
                        >
                          <DatePicker
                            format='YYYY-MM-DD HH:mm'
                            showTime={{
                              defaultValue: moment('00:00:00', 'HH:mm')
                            }}
                            className='custom-promolisting-eandearlydatepciker'
                            size='large'
                            inputReadOnly={true}
                          />
                        </Form.Item>
                      </Form>
                    </Col>
                  </Row>

                  <Row>
                    <Col span={17}></Col>
                    <Col span={7}>
                      <Form
                        form={form}
                        name='endEarlyForm'
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        scrollToFirstError
                      >
                        <Form.Item>
                          <Button
                            className='dk-btn-add  dk-btn-promo-end dk-hgt-50 dk-wd-200'
                            type='primary'
                            htmlType='submit'
                          >
                            <IntlMessages id='products.promotionlisting.setendbtn' />
                          </Button>
                        </Form.Item>
                      </Form>
                    </Col>
                  </Row>
                </>
              )}
            </div>
          </Modal>
        </div>
      )}
    </>
  ) : (
    <NotAllowedComponent
      getAccessLoading={getAccessLoading}
      textType={!isFeatureAllowed ? 2 : 1}
    />
  )
}

export default PromoListing
